export default 'https://tme.understood.org/assets/dance_shoes.31f1e778.glb'